





























































import { defineComponent, computed, getCurrentInstance, onMounted, ref } from '@vue/composition-api';
import { CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import IndustryInfo from '@/renderer/components/dialog/IndustryInfo/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import {
  BusinessTypeMap,
  industryCardList,
  industryCardListIds,
  industryTypeMap,
} from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { IS_PRIVATE } from '@/common/constant';
import guideHandler, { GuideCards } from '../composition/guideHandler';
export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    IndustryInfo,
  },
  props: {
    showMore: {
      default: true,
      type: Boolean,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const { guideCards, functionGuideCards, methods: guideMethods } = guideHandler();
    const guideData = computed(() => store.getters.noviceGuidance);
    const baseGuideDone = computed(() => guideData.value?.baseGuide?.done);
    const guideList = ref<GuideCards[]>([]);
    const industryType = ref('general');
    const showIndustryInfo = ref(false);
    const guideStepFinished = computed(() => {
      const { baseGuide } = store.getters.noviceGuidance;
      if (baseGuide) {
        return [+baseGuide.personalSpace.done, +baseGuide.collaborationSpace.done];
      }
      return [0, 0];
    });
    const welcomeStepText = computed(() => {
      const sum = guideStepFinished.value.reduce((x, y) => x + y);
      if (sum === 0) {
        return i18n_t('完成这2步');
      }
      return i18n_t('完成最后一步');
    });
    const { inGuide } = sidebarGuideHandler();
    const methods = {
      emitClick(id: number) {
        context.emit('openDetail', id);
        guideMethods.reportFunctionGuide(id, 'guide_dlg_show');
      },
      handleClick(id: number) {
        // 新手引导时，禁止执行点击事件
        const dom = document.body.querySelector('#driver-page-overlay');
        if (dom) return;
        if (inGuide.value) return;
        context.emit('closeDetail');
        if (industryCardListIds.includes(id)) {
          industryType.value = industryTypeMap.get(id) || 'general';
          showIndustryInfo.value = true;
          return;
        }
        setTimeout(() => {
          guideMethods.onGuideStep(id);
        });
      },

      getGuideList() {
        const { bussiness } = store.getters;
        const base = {
          id: 11,
          title: i18n_t('网盘使用攻略'),
          text: i18n_t('提供一站式文件安全管理、高效办公协作、在线签合同的解决方案'),
          icon: 'industry-5',
        };
        const id = BusinessTypeMap.get(bussiness) || 11;
        const info = industryCardList.find(item => item.id === id);
        if (info) {
          // 私有化 || 指引弹窗中无需显示行业卡片
          if (IS_PRIVATE || !props.showMore) {
            guideList.value = guideCards;
            return;
          }
          const newList = guideCards.concat(base).map(item => {
            if (industryCardListIds.includes(item.id)) {
              return info;
            }
            return item;
          });
          guideList.value = newList;
        }
      },
    };

    onMounted(() => {
      guideMethods.getFunctionGuideShow();
      methods.getGuideList();
      // 上报展示
      functionGuideCards.value.forEach(item => {
        if (item.show) {
          guideMethods.reportFunctionGuide(item.id, 'card_show');
        }
      });
    });
    return {
      industryType,
      showIndustryInfo,
      guideList,
      guideCards,
      functionGuideCards,
      guideStepFinished,
      baseGuideDone,
      welcomeStepText,
      ...methods,
      ...guideMethods,
    };
  },
});
